import { Component } from '@angular/core';
import { CourseCatalogueDetailsCardComponent } from '../../course-catalogue-details-card/course-catalogue-details-card.component';

@Component({
  selector: 'app-regular-course-practical-exposition',
  standalone: true,
  imports: [CourseCatalogueDetailsCardComponent],
  templateUrl: './regular-course-practical-exposition.component.html',
})
export class RegularCoursePracticalExpositionComponent {
  morningItems = [
    { title: '8:00', description: $localize`Pre-care` },
    { title: '9:00', description: $localize`Theme activity*` },
    {
      title: '10:30',
      description: $localize`Break with cookie (provided by Skillz)`,
    },
    { title: '10:45', description: $localize`Game activity*` },
    { title: '12:15', description: $localize`Lunch break` },
  ];
  dayItems = [
    { title: '13:00', description: $localize`Theme activity*` },
    {
      title: '14:30',
      description: $localize`Break with cookie (provided by Skillz)`,
    },
    { title: '14:45', description: $localize`Game activity*` },
    { title: '16:15', description: $localize`Aftercare` },
    { title: '18:00', description: $localize`End` },
  ];
}
